import { FormEvent, useRef } from 'react'
import toast from 'react-hot-toast'
import { useQueryClient } from 'react-query'
import { useSetRecoilState } from 'recoil'
import { useCreateAccount } from '../../api/auth'
import { modalOpenState } from '../../atoms/layout'
import { AccountRole } from '../../types/account-role'
import Button from '@mui/material/Button'
import Input from '../common/Input'
import Select from '../common/Select'

interface Props {
  className?: string
}

export default function NewAccountForm({ className = '' }: Props) {
  const createAccount = useCreateAccount()
  const queryClient = useQueryClient()

  const phoneNumberRef = useRef<HTMLInputElement>(null)
  const emailRef = useRef<HTMLInputElement>(null)
  const fullNameRef = useRef<HTMLInputElement>(null)
  const roleRef = useRef<HTMLSelectElement>(null)
  const passwordRef = useRef<HTMLInputElement>(null)
  const setModalOpen = useSetRecoilState(modalOpenState)

  async function submitForm(e: FormEvent) {
    e.preventDefault()
    await createAccount.mutateAsync(
      {
        password: passwordRef.current?.value,
        fullName: fullNameRef.current?.value,
        email: emailRef.current?.value,
        role: roleRef.current?.value as AccountRole,
        phoneNumber: '+98' + phoneNumberRef.current?.value?.slice(1),
      },
      {
        onSuccess: () => {
          setModalOpen(false)
          queryClient.invalidateQueries('all-accounts')
          toast.success('کاربر جدید اضافه شد.')
        },
      }
    )
  }

  return (
    <div className={`max-w-sm px-5 py-1 ${className}`}>
      <form onSubmit={submitForm} autoComplete="off">
        <div className="py-2 w-full">
          <Input
            placeholder="شماره تلفن"
            autoFocus
            type="tel"
            innerRef={phoneNumberRef}
            error={createAccount.isError}
          />
        </div>
        <div className="py-2">
          <Input
            placeholder="نام کامل"
            type="text"
            error={createAccount.isError}
            innerRef={fullNameRef}
          />
        </div>
        <div className="py-2">
          <Input
            placeholder="ایمیل"
            type="email"
            error={createAccount.isError}
            innerRef={emailRef}
          />
        </div>
        <div className="py-2">
          <Select
            placeholder="نقش"
            error={createAccount.isError}
            innerRef={roleRef}
            options={[
              { value: AccountRole.ADMIN, text: 'ادمین' },
              { value: AccountRole.NORMAL, text: 'ساده' },
            ]}
          />
        </div>
        <div className="py-2">
          <Input
            placeholder="رمز عبور"
            type="password"
            autoComplete="new-password"
            error={createAccount.isError}
            innerRef={passwordRef}
          />
        </div>
        <Button fullWidth variant="contained" sx={{ mt: 3 }}>
          ایجاد
        </Button>
      </form>
    </div>
  )
}
